<template>
    <div class="page--select_price_scheme">
        <div v-if="action=='List' || action=='View'">{{displayName(data.priceSchemeId)}}</div>
        <table v-else>
            <tr>
                <td>
                    <BaseSelect :class="isError()?'error--field':''" @input="selected" :data="data" :field="{key:'priceSchemeId', multiple:false, filterable:false, closeable:false,setup:{label:'name',value:'id'},option:items}" :action="action"/>
                    <div v-if="isError()" class="error-message">{{$t('error.priceSchemeAndMaxChargingUnitError')}}</div>
                </td>
                <td class="padding010">
                    <table class="table" v-if="Object.keys(selectedItem).length > 0">
                        <tr>
                            <td>{{$t('field.general.cash')}}</td>
                            <td>{{$t('field.general.point')}}</td>
                        </tr>
                        <tbody v-for="(item,i) in selectedItem" :key="i">
                            <tr><td colspan="2">{{$t("field.general.session", {session : i})}}</td></tr>
                            <tr v-for="(row,index) in item" :key="index">
                                <td>{{row.cash}}</td>
                                <td>{{row.point}}</td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
      </table>
    </div>
</template>

<script>
import BaseSelect from "@/views/crud/modules/BaseSelect.vue";

export default {
    props: ['data', 'field', 'k', 'action','originalOptions','options'],
    components: {
        BaseSelect
    },
    async created() {
    },
    async beforeMount() {
    },
    methods: {
        selected(obj){
            if(obj){
                let n=parseInt(obj);
                if(!isNaN(n)){
                    this.id=n;
                }
            }
            this.$emit("input", obj);
        },
        isError(){
            if(this.selectedItem)
            return Object.keys(this.selectedItem).length < this.data.maxChargingUnit && this.id != undefined?true:false;
            return false;
        },
        displayName(id){
            let obj=this.options?.priceScheme?.filter(r=>r.value==id);
            if(typeof obj != 'undefined' && obj[0] != undefined){
                return obj[0].label;
            }
        }
    },
    computed: {
        items(){
            return this.originalOptions?.priceScheme?.filter(r=>r.locId==this.data.loc_id);
        },
        selectedItem(){
            let obj=this.originalOptions?.priceScheme?.filter(r=>r.id==this.id);
            if(typeof obj != 'undefined' && obj[0] != undefined){
                let arr={};
                obj[0].priceSchemeDetails.map(r=>{
                    if(!arr[r.session]) arr[r.session]=[];
                    arr[r.session].push(r);
                })
                return arr;
            }
            return {};
        }
    },
    data() {
        return {
            id:undefined,
        }
    }
}
</script>

<style lang="scss">
    .error--field{
        .form_selection{
            border-color: red;
        }
    }
    .page--select_price_scheme {
        
        .error-message {
          font-size: small;
          color: red;
          line-height: 1.5em;
          text-align: left;
        }
        table{
            width: 100%;
            td{
                width: 50%;
                text-align: center;
                vertical-align: top;
                line-height:1.5;
                table,tr,td{
                    border: 1px solid #000;
                    border-collapse: collapse;
                }
            }
        }
        .padding010{
            padding: 0 10px;
        }
    }
</style>